export function view(value) {
  if (!value) return 'No'
  if (value.startsWith('image/')) return 'ImageFile'
  if (value === 'text/html') return 'HtmlFile'
  if (value === 'application/pdf') return 'PdfFile'
  if (value.startsWith('video/')) return 'VideoFile'
  return 'OtherFile'
}
